module.exports = __webpack_public_path__ + "img/no-pending-tasks.77ee261d.png";